import { useQuery } from "react-query";
import DataService from "../config/DataServices";

const { getRequest } = DataService()

export const useDashboard = () => {

    return useQuery({
        queryKey: ["dashboard"],
        queryFn: () => {
            return getRequest("/dashboard")
        },
    })
}
